<template>
    <div class="ade-disconnect">
        <AppList :items="disconnectAdeItems" >
            <template #checklist-station-slot="{item}">
                <div class="row centered space-between checklist-container">
                    <p class="checklist-p">{{item.title}}</p>
                    <AppChecklist
                        :title="item.title"
                        :values="stationsTitles"
                        :selected-indexes="selectedStationsIndexes"
                        class="input-item"
                        @change-checked="checkStation"
                    />
                </div>
            </template>
            <template #double-button-slot="{item}">
                <div class="row flex-end">
                    <AppButton :text="getString('unlink')" outline small @click="disconnectAde" :loading="loadingAde" />
                    <AppButton class="ml-12" :text="getString('save')" small @click="updateBusinessApiscontrinoExcludeUsers" :loading="loadingAde" />
                </div>
            </template>
        </AppList>
    </div>
</template>

<script>
import AppList from "@/shared/components/AppList.vue";
import AppButton from "@/shared/components/AppButton.vue";
import AppChecklist from "@/shared/components/AppChecklist.vue";
import {useUnchangingStore, useUserStore} from "@/console-new/stores";
import {useLanguageStore, useNotificationStore} from "@/shared/stores";
import {validateEmail} from "@/shared/helpers/strings";
import API from "@/shared/helpers/API";

export default {
    setup() {
        let unchangingStore = useUnchangingStore();
        let userStore = useUserStore();
        let notificationStore = useNotificationStore();
        let languageStore = useLanguageStore();
        return {validateEmail, getString: languageStore.getString, userStore, unchangingStore, showNotification: notificationStore.showNotification};
    },
    name: "AdeDisconnect" ,
    components: {AppChecklist, AppButton, AppList},
    data() {
        return {
            apiscontrinoUsersExcl: [],
            loadingAde: false,
        }
    },
    computed: {
        businessStations() {
            if(this.userStore.businessUsers) {
                return Object.values(this.userStore.businessUsers).filter(user => user.station);
            }
            return [];
        },
        stationsTitles() {
            let returningNames = [this.getString("online")];
            if(this.businessStations) {
                this.businessStations.forEach(station => {
                    returningNames.push(station.name);
                });
            }
            return returningNames;
        },
        selectedStationsIndexes() {
            let returningIndexes = [];
            if(!this.apiscontrinoUsersExcl.includes(null)) {
                returningIndexes.push(0);
            }
            for(let i = 0; i < this.businessStations.length; i++) {
                if(!this.apiscontrinoUsersExcl.includes(this.businessStations[i].user_id)) {
                    returningIndexes.push(i+1);
                }
            }
            return returningIndexes;
        },
        disconnectAdeItems() {
            return [
                {title: this.getString('stations'), customSlot: 'checklist-station-slot'},
                {title: '', customSlot: 'double-button-slot'},
            ]
        },
    },
    methods: {
        checkStation(newCheckedIndexes) {
            let newStationExcl = [];
            if(!newCheckedIndexes.includes(0)) {
                newStationExcl.push(null);
            }
            Object.keys(this.businessStations).forEach((stationId, index) => {
                if(!newCheckedIndexes.includes(index+1)) {
                    newStationExcl.push(this.businessStations[stationId].user_id);
                }
            });
            this.apiscontrinoUsersExcl = newStationExcl;
        },
        disconnectAde() {
            this.loadingAde = true;
            API.init().disconnectAde(this.userStore.currBusinessId, (r) => {
                this.loadingAde = false;
                if(r.result && r.result === "OK") {
                    this.showNotification('generic-success');
                    this.userStore.currBusiness.apiscontrino_id = null;
                } else {
                    this.showNotification('generic-fail');
                }
            });
        },
        getBusinessApiscontrinoExcludeUsers() {
            this.loadingAde = true;
            this.apiscontrinoUsersExcl = [];
            API.init().getBusinessApiscontrinoExcludeUsers(this.userStore.currBusinessId, (r) => {
                this.loadingAde = false;
                if(r.result && r.result === "OK") {
                    this.apiscontrinoUsersExcl = r.users;
                }
            });
        },
        updateBusinessApiscontrinoExcludeUsers() {
            this.loadingAde = true;
            API.init().updateBusinessApiscontrinoExcludeUsers(this.userStore.currBusinessId, JSON.stringify(this.apiscontrinoUsersExcl), (r) => {
                this.loadingAde = false;
                if(r.result && r.result === "OK") {
                    this.showNotification('generic-success');
                } else {
                    this.showNotification('generic-fail');
                }
            });
        }
    },
    mounted() {
        this.getBusinessApiscontrinoExcludeUsers();
        if(!this.userStore.businessUsers || !Object.keys(this.userStore.businessUsers).length) {
            this.userStore.getBusinessUsers();
        }
    },
    watch: {
        "userStore.currBusinessId": function (newVal, oldVal) {
            if (newVal !== null && newVal !== oldVal) {
                this.getBusinessApiscontrinoExcludeUsers();
                this.userStore.getBusinessUsers();
            }
        }
    }
}
</script>

<style scoped lang="scss">
.ade-disconnect {
    width: 100%;
}
</style>